import _ from "lodash";
import { connect } from "react-redux";
import React, { Component } from "react";
import * as yup from "yup";

import { carrierMemberIdValidationSchema } from "@/components/Common/InsuranceEligibility/carrierMetadata";
import { cn } from "@/lib/helpers/cn";
import { CustomForm } from "@/component-library/CustomForm";
import {
  dobValidationSchemaFactory,
  formatDate,
  noInsuranceCarrierValidationSchemaFactory,
} from "@/utils/yupSchemaUtils";
import { ProviderMemberProfileInsuranceHOC } from "@/component-library/hocs/ProviderMemberProfileInsuranceHOC";
import { unsetInsImage, uploadPatientInsuranceImage } from "@/redux/actions/auth";
import { UploadFileModalHOC } from "@/component-library";

import { PRI, SEC } from "./Profile";

class InsuranceInfo extends Component {
  constructor(props) {
    super(props);
    this.setFieldValue = null;
    this.state = {
      backImg: null,
      frontImg: null,
      frontImgPreview: null,
      groupId: props.groupId ?? null,
      isAso: props.isAso ?? null,
      profileData: props.data,
      showInsuranceCard: false,
      validationSchema: insuranceValidationSchema,
    };
  }

  componentDidMount() {
    let backImg, frontImg;

    if (PRI === this.props.type) {
      frontImg = this.props.insuranceImageUrls.pfUrl;
      backImg = this.props.insuranceImageUrls.pbUrl;
    } else {
      frontImg = this.props.insuranceImageUrls.sfUrl;
      backImg = this.props.insuranceImageUrls.sbUrl;
    }

    this.setState({
      backImg: backImg,
      frontImg: frontImg,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isAso !== this.props.isAso) {
      this.setState({ isAso: this.props.isAso ?? null });
    }

    if (prevProps.groupId !== this.props.groupId) {
      this.setState({ groupId: this.props.groupId ?? null });
    }
  }

  showInsuranceUploadPopUp = () => {
    this.setState({
      showInsuranceCard: true,
    });
  };

  onFileDelete = (fileName) => {
    if (fileName && fileName.includes("front")) {
      this.setFieldValue("card_front", null);
    }
    if (fileName && fileName.includes("back")) {
      this.setFieldValue("card_back", null);
    }
  };

  renderInsuranceForm = (formikProps) => {
    this.setFieldValue = formikProps.setFieldValue;

    let backInsuranceImage, backInsuranceStatus, frontInsuranceImage, frontInsuranceStatus;

    if (this.props.type === PRI) {
      frontInsuranceImage = _.get(this.props, "insuranceImageUrls.pfUrl");
      frontInsuranceStatus = _.get(this.props, "insuranceImageStatuses.pfStatus");
      backInsuranceImage = _.get(this.props, "insuranceImageUrls.pbUrl");
      backInsuranceStatus = _.get(this.props, "insuranceImageStatuses.pbStatus");

      if (this.state.frontImgPreview) {
        frontInsuranceImage = this.state.frontImgPreview;
        backInsuranceImage = this.state.backImgPreview;
      }
    }

    if (this.props.type === SEC) {
      frontInsuranceImage = _.get(this.props, "insuranceImageUrls.sfUrl");
      frontInsuranceStatus = _.get(this.props, "insuranceImageStatuses.sfStatus");
      backInsuranceImage = _.get(this.props, "insuranceImageUrls.sbUrl");
      backInsuranceStatus = _.get(this.props, "insuranceImageStatuses.sbStatus");

      if (this.state.frontImgPreview) {
        frontInsuranceImage = this.state.frontImgPreview;
        backInsuranceImage = this.state.backImgPreview;
      }
    }

    return (
      <ProviderMemberProfileInsuranceHOC
        addAcknowledgement={this.props.addAcknowledgement}
        className={cn("profile-insurance", this.props.className)}
        completedTitle={this.props.completedTitle}
        editTitle={this.props.editTitle}
        emptyDetails={this.props.emptyDetails}
        emptyTitle={this.props.emptyTitle}
        formikProps={formikProps}
        groupId={this.props.groupId ?? null}
        insurance={this.props.insurance}
        insuranceCardImgBackSrc={backInsuranceImage}
        insuranceCardImgBackStatus={backInsuranceStatus}
        insuranceCardImgFrontSrc={frontInsuranceImage}
        insuranceCardImgFrontStatus={frontInsuranceStatus}
        insuranceCompaniesOptions={this.props.carrierOptions}
        isAso={this.props.isAso ?? null}
        isEditing={this.props.isEditing}
        isPrimaryInsurance={this.props.type === PRI}
        onAddButtonClick={this.props.onAddButtonClick}
        onBrowseButtonClicked={this.showInsuranceUploadPopUp}
        onCancelButtonClick={() => {
          formikProps.resetForm();
          this.props.onCancelButtonClick();
        }}
        onEditButtonClick={this.props.onEditButtonClick}
        onFileDelete={this.onFileDelete}
        onInsuranceCardImgBackClick={this.props.onBackImageClick}
        onInsuranceCardImgFrontClick={this.props.onFrontImageClick}
        onSubmitButtonClick={async () => {
          await formikProps.submitForm();
        }}
        stateOfInsurancePlanOptions={this.props.stateOptions}
      />
    );
  };

  submitInsHandler = (formData, action) => {
    let data = { ...formData };

    if (data.policy_dob) {
      data.policy_dob = transformDOBsToServerStrings(formData.policy_dob);
    }

    if (data.card_front) {
      data.card_front = transformInsuranceImageUrls(formData.card_front);
    }

    if (data.card_back) {
      data.card_back = transformInsuranceImageUrls(formData.card_back);
    }

    if (PRI === this.props.type) {
      data = {
        primary_insurance: data,
      };
    }

    if (SEC === this.props.type) {
      data = {
        secondary_insurance: data,
      };
    }
    this.props.submit(data, action);
  };

  frInpHandler = (e) => {
    let value = null;
    let fileName = "";
    let uuid = this.state.profileData.username;
    let selectedFile = e.target.files[0];

    if (PRI === this.props.type) {
      value = "pf"; //primary front
      fileName = "primary_front_" + uuid;
    }
    if (SEC === this.props.type) {
      value = "sf"; //secondary front
      fileName = "secondary_front_" + uuid;
    }
    let fileType = selectedFile.type;

    this.props.uploadPatientInsuranceImage(
      { file: selectedFile, fileName, fileType },
      value,
      () => {
        let image = {};

        if (PRI === this.props.type) {
          image = this.props.priInsFront;
        }
        if (SEC === this.props.type) {
          image = this.props.secInsFront;
        }

        this.setState({
          frontImgPreview: { ...image },
        });
      },
      uuid,
    );
  };

  bckInpHandler = (e) => {
    let value = null;
    let fileName = "";
    let uuid = this.state.profileData.username;
    let selectedFile = e.target.files[0];

    if (PRI === this.props.type) {
      value = "pb"; //primary back
      fileName = "primary_back_" + uuid;
    }
    if (SEC === this.props.type) {
      value = "sb"; //secondary back
      fileName = "secondary_back_" + uuid;
    }

    let fileType = selectedFile.type;

    this.props.uploadPatientInsuranceImage(
      { file: selectedFile, fileName, fileType },
      value,
      () => {
        let image = {};

        if (PRI === this.props.type) {
          image = this.props.priInsBack;
        }
        if (SEC === this.props.type) {
          image = this.props.secInsBack;
        }
        this.setState({
          backImgPreview: { ...image },
        });
      },
      uuid,
    );
  };

  hideInsuranceUploadPopUp = () => {
    this.setState({
      backImgPreview: null,
      frontImgPreview: null,
      showInsuranceCard: false,
    });
  };

  onInsuranceDone = (insType) => {
    if (!this.state.frontImgPreview && !this.state.backImgPreview) {
      this.props.unsetInsImage(insType);
      this.setState({
        showInsuranceCard: false,
      });

      return;
    }

    if (PRI === this.props.type) {
      this.setFieldValue("card_front", this.props.priInsFront?.url);
      this.setFieldValue("card_back", this.props.priInsBack?.url);
    }

    if (SEC === this.props.type) {
      this.setFieldValue("card_front", this.props.secInsFront?.url);
      this.setFieldValue("card_back", this.props.secInsBack?.url);
    }

    this.setState({
      backImgPreview: null,
      frontImgPreview: null,
      showInsuranceCard: false,
    });
  };

  transformDOBToString = (insurance) => {
    if (insurance && insurance.policy_dob) {
      insurance.policy_dob = insurance.policy_dob.replace(/\//g, "");
    }

    return insurance;
  };

  render() {
    return (
      <>
        {this.state.showInsuranceCard && (
          <UploadFileModalHOC
            done={this.onInsuranceDone}
            insuranceHide={this.hideInsuranceUploadPopUp}
            onBackInputChange={this.bckInpHandler}
            onFrontInputChange={this.frInpHandler}
            showInsuranceCard={this.state.showInsuranceCard}
          />
        )}

        <CustomForm
          initialValues={this.transformDOBToString(this.props.insurance)}
          onSubmit={this.submitInsHandler}
          render={this.renderInsuranceForm}
          validationSchema={this.state.validationSchema}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    priInsBack: state.auth.priInsBack,
    priInsFront: state.auth.priInsFront,
    secInsBack: state.auth.secInsBack,
    secInsFront: state.auth.secInsFront,
  };
};

export default connect(mapStateToProps, {
  unsetInsImage,
  uploadPatientInsuranceImage,
})(InsuranceInfo);

export const trasformDOBsToValidStrings = (data) => {
  let updatedData = _.cloneDeep(data);
  const transformedDOBData = {
    primary_insurance: { policy_dob: "" },
    secondary_insurance: { policy_dob: "" },
  };

  if (
    Object.hasOwn(updatedData, "primary_insurance") &&
    Object.hasOwn(updatedData["primary_insurance"], "policy_dob") &&
    updatedData["primary_insurance"]["policy_dob"] != null
  ) {
    updatedData["primary_insurance"]["policy_dob"] = transformedDOBData["primary_insurance"] = {
      policy_dob: updatedData["primary_insurance"]["policy_dob"].replace(/\//g, ""),
    };
  }

  if (
    Object.hasOwn(updatedData, "secondary_insurance") &&
    Object.hasOwn(updatedData["secondary_insurance"], "policy_dob") &&
    updatedData["secondary_insurance"]["policy_dob"] != null
  ) {
    updatedData["secondary_insurance"]["policy_dob"] = transformedDOBData["secondary_insurance"] = {
      policy_dob: updatedData["secondary_insurance"]["policy_dob"].replace(/\//g, ""),
    };
  }

  return transformedDOBData;
};

export const transformDOBsToServerStrings = (policy_dob) => {
  if (policy_dob) {
    return `${policy_dob.substring(0, 2)}/${policy_dob.substring(2, 4)}/${policy_dob.substring(
      4,
      8,
    )}`;
  }
};

export const transformInsuranceImageUrls = (insuranceImageUrl) => {
  if (insuranceImageUrl && !insuranceImageUrl.startsWith("backend/insurance_cards/")) {
    return `backend/insurance_cards/${insuranceImageUrl}`;
  }

  return insuranceImageUrl;
};

yup.addMethod(yup.date, "format", formatDate); // we are extending data schema by adding our custom method

const dateValidationSchema = dobValidationSchemaFactory("MMDDYYYY");
const insuranceValidationSchema = yup.object().shape({
  carrier: yup.string().required("Carrier is required").nullable(),
  member_id: noInsuranceCarrierValidationSchemaFactory("carrier", carrierMemberIdValidationSchema),
  policy_dob: noInsuranceCarrierValidationSchemaFactory(
    "carrier",
    dateValidationSchema.nullable(),
    true,
  ),
  policy_holder_name: noInsuranceCarrierValidationSchemaFactory(
    "carrier",
    yup
      .string()
      .matches(/^[a-z A-Z-]+$/, "Digits, space & special characters are not allowed")
      .nullable(),
  ),
  policy_relationship: noInsuranceCarrierValidationSchemaFactory(
    "carrier",
    yup.string().required("Policy Holder is required").nullable(),
  ),
  state: noInsuranceCarrierValidationSchemaFactory("carrier", yup.string().nullable()),
});
